
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.083 11.667H11.667A5.833 5.833 0 005.833 17.5v40.833a5.833 5.833 0 005.834 5.834H52.5a5.833 5.833 0 005.833-5.834V37.917","stroke":"currentColor","stroke-width":"2.64","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M53.958 7.292a6.187 6.187 0 018.75 8.75L35 43.75l-11.667 2.917L26.25 35 53.958 7.292z","stroke":"currentColor","stroke-width":"2.64","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    